__turbopack_context__.v({
  "mapPinIcon": "StoreSelector-module-scss-module__ZXXvvq__mapPinIcon",
  "separator": "StoreSelector-module-scss-module__ZXXvvq__separator",
  "setMyStoreButton": "StoreSelector-module-scss-module__ZXXvvq__setMyStoreButton",
  "setMyStoreText": "StoreSelector-module-scss-module__ZXXvvq__setMyStoreText",
  "skeleton": "StoreSelector-module-scss-module__ZXXvvq__skeleton",
  "storeHours": "StoreSelector-module-scss-module__ZXXvvq__storeHours",
  "storeNameText": "StoreSelector-module-scss-module__ZXXvvq__storeNameText",
});
